import { CHECKOUT_SECRET } from 'actions/types';

export default function (state = {}, action) {
  switch (action.type) {
    case CHECKOUT_SECRET:
      return { ...state, secret: action.data };
    default:
      return state;
  }
}